export const postVerifyEmailEndpoint = 'registrazione-ms/ms/signup/confirm';
